import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { SpinLoader } from 'src/components'
import { sizes } from 'src/styles'
import { Rows } from 'src/components/layout'
import styles from './SpinningMask.scss'

const SpinningMask = ({ loading, size, children, ...domProps }) => (
  <div className={styles.wrapper}>
    <Rows className={loading && styles.transparent}>{children}</Rows>
    <div className={classnames(styles.mask, { [styles.hidden]: !loading })}>
      <SpinLoader {...domProps} size={size} />
    </div>
  </div>
)

SpinningMask.defaultProps = {
  size: 'md',
}

SpinningMask.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.oneOf(sizes),
  children: PropTypes.node,
}

export default SpinningMask
